import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";
import NoGapContentpoints from "../../Components/sub-pages/NoGapContent_point";

const CustomizedgiftswithoutCompanyBranding = () => {
    const CTAContent = [
        {
          pageName: "Customized Gifts without Company Branding",
          paragraphitalic: "Just A Personal Touch, Without A Logo",
          paragraphText:
                "Sometimes, the most powerful gifts are those that speak directly to the heart. With personalized gifts that focus purely on their taste and style, we offer the opportunity to give something truly unique without the need for corporate branding.",
          ContactFormName: "Customized Gifts without Company Branding",
        },
      ];
    
      const ListPoints = [
        {NogapHeading:"",
        Sectionparagraph:"",
        RightImgNogap:"../assests/images/customized-gifts/Customized Gifts without Company Branding.jpg",
        Heading:[
            {
                ListHeading:"Customized Home Décor",
                ListParagraph:"",
            },
            {
                ListHeading:"Personalized Gadgets & Tech Accessories ",
                ListParagraph:"",
            },
            {
                ListHeading:"Tailored Gift Sets for Every Occasion",
                ListParagraph:""
            }

        ]
        },
        
        
      ]
      
    
  return (
    <>
      <Helmet>
      <title>eYantra Branded & Customized Gifting</title>
      <meta name="description" content="eYantra offers customized gifts, branded merchandise, joining kits, welcome kits, and corporate gifts tailored for employees and branded corporate needs."/>
      <meta name="keywords" content="eyantra,customized gifts, branded merchandise, corporate gifting, joining kits,  corporate gifts, corporate gifts for employees, welcome kits, branded corporate,"/>
      </Helmet>
      <Ctapage data={CTAContent} />
      <NoGapContentpoints data={ListPoints[0]}/>
      
      <p className="text-center fs-32 w-75 d-block m-auto py-5">
      Create meaningful experiences by giving gifts that show genuine thoughtfulness, perfect for birthdays, anniversaries, or any occasion where a personal touch matters most.
      </p>
    </>
  );
};

export default CustomizedgiftswithoutCompanyBranding;
